import React, { useState } from 'react';
import { Button, Checkbox, Modal, Segment } from 'semantic-ui-react';
import { Field, Input, Label, SubmitButton, WarningRed, WarningYellow } from './styles';
import { producaov2 } from '../../../services/apis';
import { toast } from 'react-toastify';
import { getUserNode } from '../../../services/auth_node';
import { systemLogs } from '../../../services/system_logs';

export default function CodeModal({ isOpen, selectedEnvio, onClose, onSubmit }) {
  const [isLoading, setIsLoading] = useState(false);  

  const handleSubmit = async (e) => {
    e?.preventDefault();

    const formData = new FormData(e.target);

    const code = formData.get('code');
    
    if(!code) {
      swal('Aviso', 'Código de rastreio não pode ficar vazio', 'warning');
      return;
    }

    setIsLoading(true);

    try {
      const change_status = await producaov2.put(`/admin/envios/update/${selectedEnvio?.id}`, {
        status: 3,
        codigo_rastreio: code
      });

      toast.success('Alteração de código com sucesso')
      systemLogs("Alteração de código de rastreio", `O usuário ${getUserNode().id || "nao encontrado"} alterou o status de rastreio: ${selectedEnvio?.id} para: ${3} `);

      onSubmit();

    } catch (error) {
      toast.error("Houve um erro ao atualizar o codigo de rastreio");
      setIsLoading(false);
    }
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Modal.Header>Atualizar envio</Modal.Header>

      <Modal.Content as="form" onSubmit={handleSubmit}>
        <p style={{ textAlign: "center", fontWeight: 700 }}>
          Pedido: {selectedEnvio?.id_pedido}
        </p>
        <p style={{ textAlign: "center", fontWeight: 700 }}>
          {selectedEnvio?.curso?.curso}
        </p>
        
        <Field>
          <Label>Código de rastreamento</Label>
          <Input
            name="code"
            defaultValue={selectedEnvio?.codigo_rastreio}
          />
        </Field>

        <Field>
          <SubmitButton type="submit" disabled={isLoading}>
            {isLoading ? 'Enviando...' : 'Enviar'}
          </SubmitButton>
        </Field>
      </Modal.Content>

      <Modal.Actions>
        <Button negative type="button" onClick={onClose}>
          Cancelar
        </Button>
      </Modal.Actions>
    </Modal>
  );
}